import React, { createContext, useState } from 'react';

export const IsFinalContext = createContext();

export function IsFinalProvider({ children }) {
    // Set isFinal to true or false here
    const [isFinal] = useState(true);

    return (
        <IsFinalContext.Provider value={{ isFinal }}>
            {children}
        </IsFinalContext.Provider>
    );
}

export function useIsFinal() {
    const context = React.useContext(IsFinalContext);
    if (!context) {
        throw new Error('useIsFinal must be used within an IsFinalProvider');
    }
    return context;
}
